export default "__VITE_ASSET__CLbqIHRj__"